import Dishes from './Dishes'

export default Dishes
export { dataKey } from './dataKey'
export { DishTechCard } from './DishTechCard'
